module.exports = __webpack_public_path__ + "static/media/facebook (4).93cc8844.svg";